import { isKeyOf } from 'simplytyped';

export function assertKeyExists<
  T extends object,
  K extends string | number | symbol
>(obj: T, key: K): asserts obj is T & Record<K, unknown> {
  if (!isKeyOf(obj, key)) {
    throw new Error(`Key ${String(key)} does not exist in this object.`);
  }
}
